import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, mergeProps as _mergeProps, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "columns" }
const _hoisted_2 = { class: "column" }
const _hoisted_3 = { class: "columns" }
const _hoisted_4 = { class: "column is-10" }
const _hoisted_5 = { class: "columns" }
const _hoisted_6 = { class: "column is-10" }
const _hoisted_7 = { class: "columns" }
const _hoisted_8 = { class: "column is-3" }
const _hoisted_9 = { class: "columns" }
const _hoisted_10 = { class: "column is-narrow" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_o_icon = _resolveComponent("o-icon")!
  const _component_o_loading = _resolveComponent("o-loading")!
  const _component_o_input = _resolveComponent("o-input")!
  const _component_o_field = _resolveComponent("o-field")!
  const _component_Field = _resolveComponent("Field")!
  const _component_o_button = _resolveComponent("o-button")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_o_loading, {
      active: _ctx.isLoginPageLoading,
      "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isLoginPageLoading) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_o_icon, {
          pack: "fa",
          icon: "spinner",
          size: "large",
          spin: "",
          variant: "primary"
        })
      ]),
      _: 1
    }, 8, ["active"]),
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "columns is-centered" }, [
      _createElementVNode("div", { class: "column" }, [
        _createElementVNode("p", null, "Log into your account")
      ])
    ], -1)),
    _createVNode(_component_Form, {
      ref: "formValidator",
      onSubmit: _ctx.onSubmit,
      "validation-schema": _ctx.schema
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_Field, {
                    name: "form.Username",
                    modelValue: _ctx.form.Username,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.Username) = $event))
                  }, {
                    default: _withCtx(({ field, meta, errors }) => [
                      _createVNode(_component_o_field, {
                        label: "Email Address",
                        variant: errors[0] ? 'danger' : '',
                        message: errors[0] ? errors[0] : '',
                        labelFor: "form.Username"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_o_input, _mergeProps({
                            placeholder: "Email Address",
                            modelValue: _ctx.form.Username,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.Username) = $event))
                          }, field, { id: "form.Username" }), null, 16, ["modelValue"])
                        ]),
                        _: 2
                      }, 1032, ["variant", "message"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_Field, {
                    name: "form.Password",
                    modelValue: _ctx.form.Password,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.Password) = $event))
                  }, {
                    default: _withCtx(({ field, meta, errors }) => [
                      _createVNode(_component_o_field, {
                        label: "Password",
                        variant: errors[0] ? 'danger' : '',
                        message: errors[0] ? errors[0] : '',
                        labelFor: "form.Password"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_o_input, _mergeProps({
                            placeholder: "Password",
                            modelValue: _ctx.form.Password,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.Password) = $event))
                          }, field, {
                            id: "form.Password",
                            type: "password",
                            "password-reveal": ""
                          }), null, 16, ["modelValue"])
                        ]),
                        _: 2
                      }, 1032, ["variant", "message"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_o_button, {
                  variant: "jbm-info",
                  class: "is-fullwidth-mobile",
                  pack: "fas",
                  "native-type": "submit"
                }, {
                  default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                    _createTextVNode(" Login ", -1)
                  ]))]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["onSubmit", "validation-schema"])
  ], 64))
}